import React, {Component, useEffect, useState} from "react";
import {Button, Form, Input, Modal, notification, Table, Tooltip} from "antd";
import {addCampaignImage, fetchRequest, updateCampaignImage} from "../../util/APIUtils";
import {PlusOutlined, SearchOutlined} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {showAxiosError} from "../../util/Helpers";

class HomePageCampaignImage extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            content: [],
            total: 0,
            current: 1,
            pageSize: 5,
            pageSizeOptions: ['5', '10', '20', '50', '100'],
            loading: false,
            searchQuery: '',
            keySearchQuery: '',
            accessor: 'recordId',
            direction: 'desc',
            openExportExcelModal: false,
            visible: false,
            campaignModalContent: null
        };
        this.fetchData = this.fetchData.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.setSearchQuery = this.setSearchQuery.bind(this);
        this.showModal = this.showModal.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let self = this;
        this.setState({loading: true});
        const {accessor, direction, current, pageSize, searchQuery, keySearchQuery} = self.state;
        fetchRequest({}, `/campaignImage/fetch?page=${current - 1}&size=${pageSize}${keySearchQuery + searchQuery}&sort=${accessor},${direction}`)
            .then(response => {
                let {number, size, totalElements, content} = response.data;
                this.setState({
                    loading: false,
                    current: number + 1,
                    pageSize: size,
                    total: totalElements,
                    content
                });
            }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: 'Hata',
                    description: 'Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!'
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: 'Hata',
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message: 'Hata',
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
            this.setState({loading: false});
        });
    }

    onChange(pagination, filters, sorter, extra) {
        let searchQuery = '';
        if (filters.baseHeader && filters.baseHeader.length > 0) {
            searchQuery = searchQuery + `&baseHeader=${filters.baseHeader[0]}`;
        }
        if (filters.description && filters.description.length > 0) {
            searchQuery = searchQuery + `&description=${filters.description[0]}`;
        }
        if (filters.termsOfUse && filters.termsOfUse.length > 0) {
            searchQuery = searchQuery + `&termsOfUse=${filters.termsOfUse[0]}`;
        }

        this.setState({
            searchQuery,
            accessor: sorter.field ? sorter.field : this.state.accessor,
            direction: sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : this.state.direction,
            current: pagination.current,
            pageSize: pagination.pageSize
        }, () => this.fetchData());
    }

    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    }

    handleReset(clearFilters) {
        clearFilters();
        this.setState({searchText: ''});
    }

    handleMenuClick(e) {
        // let item = e.item;
    }

    getColumnSearchProps = (dataIndex, searchText) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div style={{padding: 8}}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={searchText}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{width: 188, marginBottom: 8, display: 'block'}}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined/>}
                    size="small"
                    style={{width: 90, marginRight: 8}}
                >
                    Ara
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
                    Temizle
                </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}}/>,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    setSearchQuery(text) {
        let self = this;
        self.setState({keySearchQuery: text, total: 0, current: 1, pageSize: 5}, () => self.fetchData());
    }

    showModal(record) {
        this.setState({campaignModalContent: record})
        this.setState({visible: true})
    }

    callbackModel = () => {
        this.setState({visible: false})
    }


    render() {

        const columns = [
            {
                title: '#',
                dataIndex: 'index',
                key: 'index',
                width: '3%',
                render: (text, record, index) => (
                    <label>{index + 1}</label>
                )
            },
            {
                title: 'Fotoğraf İsmi',
                dataIndex: 'name',
                key: 'name',
                width: '10%',
                sorter: true,
                ...this.getColumnSearchProps('baseHeader', 'Başlık ile ara.'),
            },
            {
                title: 'Fotoğraf Adresi',
                dataIndex: 'imagePath',
                key: 'imagePath',
                width: '10%',
            },
            {
                title: 'operation',
                dataIndex: 'operation',
                width: '5%',
                render: (_, record) =>
                    content.length >= 1 ? (
                        <a onClick={() => this.showModal(record)}>Düzenle</a>
                    ) : null,
            },
        ];

        const {total, current, pageSize, pageSizeOptions, content, visible} = this.state;

        return (
            <div className="my-payment-container">
                <div className="page-content">
                    <Tooltip placement="top" title="Kampanya Ekle">
                        <Button onClick={() => this.showModal()} type="primary" shape="circle" icon={<PlusOutlined/>}
                                size="large"/>
                    </Tooltip>
                    {visible && <HomePageCampaignImageModal campaignModalContent={this.state.campaignModalContent}
                                                            callbackModal={this.callbackModel}
                                                            visible={this.state.visible}/>}
                    <Table dataSource={content}
                           rowKey={record => record.recordId}
                           size="middle"
                           columns={columns}
                           onChange={this.onChange}
                           loading={this.state.loading}
                           locale={{
                               filterConfirm: 'Tamam',
                               filterReset: 'Temizle'
                           }}
                           pagination={{
                               total,
                               current,
                               pageSize,
                               pageSizeOptions,
                               showSizeChanger: true,
                               showQuickJumper: true,
                               showTotal: (total) => `Toplam ${total} kayıt`
                           }}
                    />

                </div>
            </div>
        );
    }
}

function HomePageCampaignImageModal(props) {
    const [form] = Form.useForm();
    const [campaignValue] = useState(props.campaignModalContent);

    useEffect(() => {
        if (campaignValue === undefined) {
            form.setFieldsValue({});
        }
        if (campaignValue !== undefined) {
            form.setFieldsValue({
                name: campaignValue.name,
            });
        }
    })

    function onFinish(values) {
        if (campaignValue === undefined) {
            const imagePath = values.imagePath.split("\\");
            values.imagePath = imagePath[imagePath.length - 1]
            addCampaignImage(values).then((response) => {
                notification.success({
                    message: "Başarılı",
                    description: "Kampanya başarılı bir şekilde kaydedildi.",
                })
            }).catch((error) => {
                showAxiosError(error.response);
            })
        }
        if (campaignValue !== undefined) {
            values.recordId = campaignValue.recordId;
            const imagePath = values.imagePath.split("\\");
            values.imagePath = imagePath[imagePath.length - 1]
            updateCampaignImage(values).then((response) => {
                notification.success({
                    message: "Başarılı",
                    description: "Kampanya başarılı bir şekilde kaydedildi.",
                })
            }).catch((error) => {
                showAxiosError(error.response);
            })
        }
    }

    const handleOk = (e) => {
        form
            .validateFields()
            .then((values) => {
                onFinish(values);
                props.callbackModal();
            })
    };

    const handleCancel = (e) => {
        props.callbackModal();
    };


    return (
        <div>
            <Modal
                title="Kampanya Detayları"
                visible={props.visible}
                onOk={handleOk}
                onCancel={handleCancel}
                okButtonProps={{
                    disabled: false,
                }}
                cancelButtonProps={{
                    disabled: false,
                }}
                okText="Kaydet"
                cancelText="İptal"
            >
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item
                        label="Fotoğraf İsmi"
                        name="name"
                    >
                        <Input type="text" name="name" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="Kampanya Fotoğrafı"
                        name="imagePath"
                    >
                        <Input type="file" name="imagePath" size="large"/>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    )
}

export default HomePageCampaignImage;


// WEBPACK FOOTER //
// ./src/page/homePageCampaignImage/HomePageCampaignImage.js